import React from 'react';

const PERIODS = ['Weekly', 'Monthly', 'Quarterly'];

export function KPISystemRulesTab({
  definitions,
  scoringRules,
  editingRules,
  setEditingRules,
  onSaveRule,
  loading,
}) {
  return (
    <div className="rules-tab">
      {definitions.map((def) => (
        <div key={def.id} className="definition-rules-section">
          <h4>{def.kpi_name}</h4>
          <table className="rules-table">
            <thead>
              <tr>
                <th>Period</th>
                <th>Target Value</th>
                <th>Points</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {PERIODS.map((period) => {
                const rule = (scoringRules[def.id] || []).find((r) => r.period === period);
                const isEditing =
                  editingRules !== null &&
                  editingRules.kpi_definition_id === def.id &&
                  editingRules.period === period;
                return (
                  <tr key={period}>
                    <td>{period}</td>
                    <td>
                      {isEditing ? (
                        <input
                          type="number"
                          step="0.01"
                          min="0"
                          value={editingRules.target_value}
                          onChange={(e) =>
                            setEditingRules({ ...editingRules, target_value: e.target.value })
                          }
                          aria-label={`${period} target value for ${def.kpi_name}`}
                        />
                      ) : (
                        rule?.target_value || 'Not set'
                      )}
                    </td>
                    <td>
                      {isEditing ? (
                        <input
                          type="number"
                          step="0.01"
                          min="0"
                          value={editingRules.points_for_achievement}
                          onChange={(e) =>
                            setEditingRules({
                              ...editingRules,
                              points_for_achievement: e.target.value,
                            })
                          }
                          aria-label={`${period} points for ${def.kpi_name}`}
                        />
                      ) : (
                        rule?.points_for_achievement || 'Not set'
                      )}
                    </td>
                    <td>
                      {isEditing ? (
                        <>
                          <button
                            className="btn-edit"
                            onClick={() => onSaveRule(rule?.id)}
                            disabled={loading}
                          >
                            Save
                          </button>
                          <button
                            className="btn-secondary"
                            onClick={() => setEditingRules(null)}
                            disabled={loading}
                          >
                            Cancel
                          </button>
                        </>
                      ) : (
                        <button
                          className="btn-edit"
                          onClick={() =>
                            setEditingRules(
                              rule
                                ? {
                                    ...rule,
                                    target_value: String(rule.target_value ?? ''),
                                    points_for_achievement: String(rule.points_for_achievement ?? ''),
                                  }
                                : {
                                    kpi_definition_id: def.id,
                                    period,
                                    target_value: '',
                                    points_for_achievement: '',
                                  }
                            )
                          }
                          disabled={loading}
                        >
                          {rule ? 'Edit' : 'Add'}
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
}
